import React from "react";
import Layout from "../../../Layouts/Layout";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import LegalbirdAuthenticatedLoaderPage from "../../Loading/LegalbirdAuthenticatedLoaderPage";
import { Conversation } from "../../../../types/Entities/Messaging/Conversation";
import MessageCenter from "../../../../components/Messaging/MessageCenter/MessageCenter";
import Container from "../../../../components/Container/Container";
import { Helmet } from "react-helmet-async";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function MessageCenterPage() {
  const conversationFilter = {
    "exists[containedMessages]": true,
  };

  const { data: conversations, isLoading: isLoadingConversations } = useQuery<Array<Conversation>, Error>({
    queryKey: queryKeys.collection("/conversations", conversationFilter),
    queryFn: () => fetchCollection("/conversations", conversationFilter),
  });

  const { data: minimalCases, isLoading: isLoadingMinimalCases } = useQuery({
    queryKey: queryKeys.collection("/collection/cases"),

    queryFn: () => fetchCollection("/collection/cases"),
  });

  if (isLoadingConversations || isLoadingMinimalCases) {
    return <LegalbirdAuthenticatedLoaderPage />;
  }

  return (
    <LayoutAuthenticated>
      <Helmet>
        <title>Servicewelt Nachrichtenübersicht | Legalbird</title>
      </Helmet>
      <MessageCenter minimalCases={minimalCases || []} conversations={conversations || []} />
    </LayoutAuthenticated>
  );
}
